import { defineMessages, useIntl } from 'react-intl';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSocialNetworks } from '@package/actions';
import cx from 'classnames';
import Button from '@package/components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faFlickr,
  faInstagram,
  faLinkedin,
  faSlideshare,
  faSoundcloud,
  faTumblr,
  faWhatsapp,
  faXTwitter,
  faYoutube,
  faThreads,
  faBluesky,
} from '@fortawesome/free-brands-svg-icons';

// import styles from './SocialLinks.module.less';

const messages = defineMessages({
  visitUsOn: {
    id: 'Visit us on {siteName}',
    defaultMessage: 'Visit us on {siteName}',
  },
});

const SocialLinks = ({ invert, className }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSocialNetworks());
  }, [dispatch]);

  const result = useSelector((state) => {
    return state.socialNetworks;
  });

  if (!result.loaded || result.error || !result?.data?.items) {
    return null;
  }

  const icons = {
    facebook: faFacebook,
    soundcloud: faSoundcloud,
    flickr: faFlickr,
    instagram: faInstagram,
    linkedin: faLinkedin,
    slideshare: faSlideshare,
    tumblr: faTumblr,
    x: faXTwitter,
    whatsapp: faWhatsapp,
    youtube: faYoutube,
    threads: faThreads,
    bluesky: faBluesky,
  };

  return (
    <div className={cx('social-links', { [className]: className })}>
      {result.data.items.map((network, id) => {
        const { social_network, social_network_url } = network;

        if (!social_network || !social_network_url) return null;

        return (
          <Button
            key={`${social_network_url}-${id}`}
            href={social_network_url}
            small
            circle
            link
            invert={invert}
            rel="noopener noreferrer"
            target="_blank"
            title={intl.formatMessage(messages.visitUsOn, {
              siteName: social_network.toLowerCase(),
            })}
          >
            <FontAwesomeIcon icon={icons[social_network?.toLowerCase()]} />
          </Button>
        );
      })}
    </div>
  );
};

export default SocialLinks;
